/**
 * @(#)2019/7/16.
 * 文件上传封装 oss
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { DB } from "../DB";
import { message } from "antd";
import { isString } from "lodash";
import BaseUpload from "./baseUpload";
import { PostXhr, GetXhr } from "../baseRequest";
import { get, random, objToFormData, merge } from "../index";

/**
 * 原生实现请求，避免引入jq,获得凭证
 *
 * @param {string} url
 * @param {string} accessToken
 * @returns
 */
const getAjax = function (url, accessToken, headers) {
  if ([url].some((p) => [undefined, null, ""].includes(p))) {
    console.error(`上传组件必须传入获得凭证参数,当前参数为 url：${url} `);
    throw `上传组件必须传入获得凭证参数,当前参数为 url：${url} `;
  }
  return GetXhr.new(url, {
    "Content-Type": "application/x-www-form-urlencoded",
    "Access-Token": accessToken,
    ...headers,
  }).xhrSend();
};

/**
 * 文件后缀获得，包含“**.**”
 *
 * @param {string} filename
 * @returns
 */
function fileSuffix(filename) {
  const splitFile = filename.split(".");
  const len = splitFile.length;
  return "." + splitFile[len - 1];
}

function calculate_object_name(g_dirname, group, filename, isReal) {
  if (!filename) {
    return "";
  }
  let suffix = fileSuffix(filename);
  let g_object_name = g_dirname + random(15) + suffix;
  if (!!group) {
    if (g_dirname.indexOf("/") == -1) {
      g_dirname += "/";
    }
    g_object_name = decodeURIComponent(
      g_dirname + group + "/" + random(14) + suffix
    );
  }
  return g_object_name;
}

/**
 * 获得签名
 *
 * @param {string} url
 * @param {string} AccessToken
 * @param {object} headers 扩展请求头
 * @returns Promise
 */
export const getSign = function (url, AccessToken, headers = {}) {
  return getAjax(url, AccessToken, headers)
    .then((res) => res)
    .catch((err) => {
      console.error("获得oss签名失败", err);
      message.error(isString(err) ? err : "获得oss签名失败");
    });
};

export const urlToFile = BaseUpload.urlToFile;

/**
 * 文件上传
 *
 * @class UploadFile
 */
class UploadFile extends BaseUpload {
  constructor(param) {
    super(param);
    const {
      url,
      AccessToken,
      policyUrl,
      folder = "",
      headers = {},
      uploadCallback,
      isFileNameConfusion = false,
    } = param;
    this.url = policyUrl || url;
    this.config = null;
    this.folder = folder;
    this.AccessToken = AccessToken || "";
    this.uploadCallback = uploadCallback || function () {};
    this.headers = merge({ ossType: "ALIYUNOSS " }, headers);
    this.isFileNameConfusion = isFileNameConfusion;
  }

  get ossUrl() {
    return get(this.config, ["host", "form-action"], null);
  }

  /**
   * 获得上传oss签名
   *
   * @param {*} error
   * @param {*} ossFactory
   * @returns
   * @memberof UploadFile
   */
  async getSign(error, ossFactory) {
    const url = this.url;
    const accessToken = this.AccessToken;
    if (this.config && !error) {
      return this.config;
    } else {
      let config = await this.requestPolicy(
        getSign,
        url,
        accessToken,
        this.headers
      );
      if (ossFactory instanceof Function) {
        this.config = ossFactory(config);
      } else {
        this.config = config;
      }
      DB.set("oss", this.config);
      return this.config;
    }
  }

  formParams = (file, folder) => {
    if (folder) this.folder = folder + "/";
    let config = this.config;
    const key = get(config, ["dir", "key"], null);
    let isFileNameConfusion = this.isFileNameConfusion;
    let keyName; //上传的路径
    //是否用文件原名上传，注意：用原名上传可能会带来文件被覆盖的隐患
    if (isFileNameConfusion === true) {
      keyName = key + "/" + this.folder + file.name;
    } else {
      keyName = calculate_object_name(key, this.folder, file.name, true);
    }
    let params = {
      name: file.name,
      policy: config.policy,
      signature: config.signature,
      success_action_status: "200",
      OSSAccessKeyId: config.accessid,
      key: keyName,
    };
    return merge(params, this.propsFormParams(file, params));
  };

  /**
   * 上传文件到oss
   *
   * @param {*} file
   * @memberof UploadFile
   */
  uploadFileAction = async (file) => {
    if (this.ossUrl == null) {
      await this.getSign();
    }
    const formParams = this.formParams(file);
    const formData = objToFormData(formParams);
    formData.append("file", file);
    await PostXhr.new(this.ossUrl).xhrSend(formData);
    const key = formParams.key;
    const result = `${this.ossUrl}/${key}`;
    this.uploadCallback && (await this.uploadCallback({ file, url: result }));
    return result;
  };

  uploadFile = (...args) => {
    return this.uploadFileAction(...args);
  };
}

export default UploadFile;



// WEBPACK FOOTER //
// ./src/yx-widget/utils/upload/uploadFile.js